import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { ShippingRegionHeader } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ShippingRegionHeaderService extends TmsWebBaseEditService<ShippingRegionHeader, ShippingRegionHeader> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('ShippingRegionHeader', $localize`Shipping Region Header`);
  }
}
